<!--suppress XmlInvalidId, HtmlUnknownBooleanAttribute, TypeScriptUnresolvedVariable, AngularUndefinedBinding -->

<div class="row mt-2">
  <div class="col-10">
    <nav class="breadcrumb-one" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="javascript:void(0);">
            <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
          </a>
        </li>
        <li class="breadcrumb-item active" aria-current="page" translate><a href="/private/settings" translate>Settings</a></li>
        <li class="breadcrumb-item active" aria-current="page" translate>API Keys</li>
        <li class="breadcrumb-item">
          <a href="https://www.youtube.com/watch?v=EldaEjIfFa4" target="_blank">
            <svg width="15" height="15" viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
              <g id="Group">
                <path id="Path" fill="#06209f" stroke="none"
                      d="M 683.015686 117.331543 C 526.902344 -38.973694 273.638733 -39.129089 117.331566 116.982361 C -38.973663 273.097717 -39.130989 526.363159 116.984306 682.670349 C 273.095764 838.975586 526.36322 839.130981 682.670349 683.017639 C 838.973694 526.906128 839.130981 273.636841 683.015686 117.331543 Z M 455.850311 653.819031 C 455.850311 659.991028 450.848602 664.988892 444.68042 664.988892 L 355.321472 664.988892 C 349.15332 664.988892 344.151642 659.991028 344.151642 653.819031 L 344.151642 322.097748 C 344.151642 315.925751 349.15332 310.927887 355.321472 310.927887 L 444.68042 310.927887 C 450.848602 310.927887 455.850311 315.923828 455.850311 322.097748 L 455.850311 653.819031 Z M 400.000977 264.571594 C 364.281158 264.571594 335.218811 235.513062 335.218811 199.791382 C 335.218811 164.073486 364.279266 135.009216 400.000977 135.009216 C 435.722656 135.009216 464.783112 164.071594 464.783112 199.791382 C 464.783112 235.513062 435.718811 264.571594 400.000977 264.571594 Z"/>
              </g>
              <g id="g1"/>
            </svg>
          </a>
        </li>
      </ol>
    </nav>
  </div>
  <div class="col-2">
    <button *ngIf="!submitting && (isMerchant || isManager)" class="btn btn-primary" translate (click)="submitForm()">Save Changes</button>
  </div>
</div>
<div [hidden]="loading" *ngIf="myBusiness" class="account-settings-container layout-top-spacing">
  <!-- API Settings  -->
  <div *ngIf="apiSettings && (isManager || isMerchant)" class="api-content">
    <div class="scrollspy-example" data-spy="scroll" data-target="#account-settings-scroll" data-offset="-100">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 layout-spacing">
          <form id="api-info" [formGroup]="form" class="section general-info">
            <div class="info">
              <h6 translate>API Settings</h6>
              <div class="row">
                <div class="col-lg-11 mx-auto">
                  <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 mt-md-0 mt-4">
                      <div class="form">
                        <!---->
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label for="firstName" translate>API ID</label>
                              <input formControlName="apiId" [contentEditable]="false" type="text" class="form-control mb-1" placeholder="{{'API ID' | translate}}">
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label for="lastName" translate>API Secret Key</label>
                              <input formControlName="apiKey" [contentEditable]="false" type="text" class="form-control mb-1" placeholder="{{'API Secret Key' | translate}}">
                            </div>
                          </div>
                        </div>
                        <!---->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col" *ngIf="hasSettlementWebhookService && (isMerchant || isManager)">
      <!-- Web Hook Settlement -->
      <div class="settlementWebhook">
        <div class="scrollspy-example" data-spy="scroll" data-target="#account-settings-scroll" data-offset="-100">
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 layout-spacing">
              <form id="settlementWebhookForm" [formGroup]="settlementWebhookForm" class="section general-info">
                <div class="info">
                  <h6 translate>Settlement Webhook</h6>
                  <div class="row">
                    <div class="col-lg-11 mx-auto">
                      <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 mt-md-0 mt-4">
                          <div class="form">
                            <!---->
                            <div class="row">
                              <div class="col-sm-12">
                                <div class="form-group">
                                  <label for="webhookUrl" translate>URL</label>
                                  <input style="direction: ltr" id="webhookUrl" formControlName="webhookUrl" type="text" class="form-control mb-1" placeholder="{{'Webhook Url' | translate}}">
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-sm-12">
                                <div class="row">
                                  <div class="col">
                                    <div class="form-group">
                                      <label for="httpHeader1" translate>HTTP Header 1</label>
                                      <input id="httpHeader1" formControlName="httpHeader1" type="text" class="form-control mb-1" placeholder="{{'HTTP Header 1' | translate}}">
                                    </div>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <label for="httpHeader1Value" translate>HTTP Header 1 Value</label>
                                      <input id="httpHeader1Value" formControlName="httpHeader1Value" type="text" class="form-control mb-1" placeholder="{{'HTTP Header 1 Value' | translate}}">
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-sm-12">
                                <div class="row">
                                  <div class="col">
                                    <div class="form-group">
                                      <label for="httpHeader2" translate>HTTP Header 2</label>
                                      <input id="httpHeader2" formControlName="httpHeader2" type="text" class="form-control mb-1" placeholder="{{'HTTP Header 2' | translate}}">
                                    </div>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <label for="httpHeader2Value" translate>HTTP Header 2 Value</label>
                                      <input id="httpHeader2Value" formControlName="httpHeader2Value" type="text" class="form-control mb-1" placeholder="{{'HTTP Header 2 Value' | translate}}">
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <button class="btn btn-primary" translate (click)="testSettlementWebhook()">Test</button>
                              </div>
                            </div>
                            <!---->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Web Hook Settlement -->
    </div>
    <div class="col" *ngIf="myPartners && myPartners.length > 0 && myBusiness.licenseType != 'marketer' && !isAccountant && !isSales">
      <!-- Partner Activation Web Hook Settlement -->
      <div class="partnerActivationWebhook">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 layout-spacing">
            <form id="partnerActivationWebhookForm" [formGroup]="partnerActivationWebhookForm" class="section general-info">
              <div class="info">
                <h6 translate>Partner Activation Webhook</h6>
                <div class="row">
                  <div class="col-lg-11 mx-auto">
                    <div class="row">
                      <div class="col-xl-12 col-lg-12 col-md-12 mt-md-0 mt-4">
                        <div class="form">
                          <!---->
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label for="webhookUrlActivation" translate>URL</label>
                                <input style="direction: ltr" id="webhookUrlActivation" formControlName="webhookUrl" type="text" class="form-control mb-1" placeholder="{{'Webhook Url' | translate}}">
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="row">
                                <div class="col">
                                  <div class="form-group">
                                    <label for="httpHeader1Activation" translate>HTTP Header 1</label>
                                    <input id="httpHeader1Activation" formControlName="httpHeader1" type="text" class="form-control mb-1" placeholder="{{'HTTP Header 1' | translate}}">
                                  </div>
                                </div>
                                <div class="col">
                                  <div class="form-group">
                                    <label for="httpHeader1ValueActivation" translate>HTTP Header 1 Value</label>
                                    <input id="httpHeader1ValueActivation" formControlName="httpHeader1Value" type="text" class="form-control mb-1" placeholder="{{'HTTP Header 1 Value' | translate}}">
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="row">
                                <div class="col">
                                  <div class="form-group">
                                    <label for="httpHeader2Activation" translate>HTTP Header 2</label>
                                    <input id="httpHeader2Activation" formControlName="httpHeader2" type="text" class="form-control mb-1" placeholder="{{'HTTP Header 2' | translate}}">
                                  </div>
                                </div>
                                <div class="col">
                                  <div class="form-group">
                                    <label for="httpHeader2ValueActivation" translate>HTTP Header 2 Value</label>
                                    <input id="httpHeader2ValueActivation" formControlName="httpHeader2Value" type="text" class="form-control mb-1" placeholder="{{'HTTP Header 2 Value' | translate}}">
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col">
                              <button class="btn btn-primary" translate (click)="testPartnerActivationWebhook()">Test</button>
                            </div>
                          </div>
                          <!---->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- End of Web Hook Partner Activation -->
    </div>
    <div class="col">
      <!-- Payment Web Hook Settlement -->
      <!--      <div class="paymentWebhook">-->
      <!--        <div class="row">-->
      <!--          <div class="col-xl-12 col-lg-12 col-md-12 layout-spacing">-->
      <!--            <form id="paymentWebhookForm" [formGroup]="paymentWebhookForm" class="section general-info">-->
      <!--              <div class="info">-->
      <!--                <h6 translate>Payment Webhook</h6>-->
      <!--                <div class="row">-->
      <!--                  <div class="col-lg-11 mx-auto">-->
      <!--                    <div class="row">-->
      <!--                      <div class="col-xl-12 col-lg-12 col-md-12 mt-md-0 mt-4">-->
      <!--                        <div class="form">-->
      <!--                          &lt;!&ndash;&ndash;&gt;-->
      <!--                          <div class="row">-->
      <!--                            <div class="col-sm-12">-->
      <!--                              <div class="form-group">-->
      <!--                                <label for="webhookUrlPayment" translate>URL</label>-->
      <!--                                <input id="webhookUrlPayment" style="direction: ltr" formControlName="webhookUrl" type="text" class="form-control mb-1" placeholder="{{'Webhook Url' | translate}}">-->
      <!--                              </div>-->
      <!--                            </div>-->
      <!--                          </div>-->
      <!--                          <div class="row">-->
      <!--                            <div class="col-sm-12">-->
      <!--                              <div class="row">-->
      <!--                                <div class="col">-->
      <!--                                  <div class="form-group">-->
      <!--                                    <label for="httpHeader1Payment" translate>HTTP Header 1</label>-->
      <!--                                    <input id="httpHeader1Payment" formControlName="httpHeader1" type="text" class="form-control mb-1" placeholder="{{'HTTP Header 1' | translate}}">-->
      <!--                                  </div>-->
      <!--                                </div>-->
      <!--                                <div class="col">-->
      <!--                                  <div class="form-group">-->
      <!--                                    <label for="httpHeader1ValuePayment" translate>HTTP Header 1 Value</label>-->
      <!--                                    <input id="httpHeader1ValuePayment" formControlName="httpHeader1Value" type="text" class="form-control mb-1" placeholder="{{'HTTP Header 1 Value' | translate}}">-->
      <!--                                  </div>-->
      <!--                                </div>-->
      <!--                              </div>-->
      <!--                            </div>-->
      <!--                          </div>-->
      <!--                          <div class="row">-->
      <!--                            <div class="col-sm-12">-->
      <!--                              <div class="row">-->
      <!--                                <div class="col">-->
      <!--                                  <div class="form-group">-->
      <!--                                    <label for="httpHeader2Payment" translate>HTTP Header 2</label>-->
      <!--                                    <input id="httpHeader2Payment" formControlName="httpHeader2" type="text" class="form-control mb-1" placeholder="{{'HTTP Header 2' | translate}}">-->
      <!--                                  </div>-->
      <!--                                </div>-->
      <!--                                <div class="col">-->
      <!--                                  <div class="form-group">-->
      <!--                                    <label for="httpHeader2ValuePayment" translate>HTTP Header 2 Value</label>-->
      <!--                                    <input id="httpHeader2ValuePayment" formControlName="httpHeader2Value" type="text" class="form-control mb-1" placeholder="{{'HTTP Header 2 Value' | translate}}">-->
      <!--                                  </div>-->
      <!--                                </div>-->
      <!--                              </div>-->

      <!--                            </div>-->
      <!--                          </div>-->
      <!--                          <div class="row">-->
      <!--                            <div class="col">-->
      <!--                              <div class="form-group">-->
      <!--                                <label for="apiVersion" translate>API Version</label>-->
      <!--                                <select id="apiVersion" formControlName="version" type="text" class="form-control mb-1">-->
      <!--                                  <option value="v1" translate>v1</option>-->
      <!--                                  <option value="v2" translate>v2</option>-->
      <!--                                </select>-->
      <!--                              </div>-->
      <!--                            </div>-->
      <!--                            <div class="col" >-->
      <!--                              <span translate>For more information, check Payment webhook</span><span translate><a href="https://developer.paylink.sa/docs/payment-webhook">here</a></span>-->
      <!--                            </div>-->
      <!--                          </div>-->
      <!--                          <div class="row">-->
      <!--                            <div class="col">-->
      <!--                              <button class="btn btn-primary" translate (click)="testPaymentWebhook()">Test</button>-->
      <!--                            </div>-->
      <!--                          </div>-->
      <!--                          &lt;!&ndash;&ndash;&gt;-->
      <!--                        </div>-->
      <!--                      </div>-->
      <!--                    </div>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </form>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="paymentWebhook">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 layout-spacing">
            <form id="paymentWebhookForm" [formGroup]="paymentWebhookForm" class="section general-info">
              <div class="info">
                <h6 translate>Payment Webhook</h6>
                <div class="row">
                  <div class="col-lg-11 mx-auto">
                    <div class="row">
                      <div class="col-xl-12 col-lg-12 col-md-12 mt-md-0 mt-4">
                        <div class="form">
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label for="webhookUrlPayment" translate>URL</label>
                                <input id="webhookUrlPayment" style="direction: ltr" formControlName="webhookUrl" type="text" class="form-control mb-1" placeholder="{{'Webhook Url' | translate}}">
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label for="httpHeader1Payment" translate>HTTP Header 1</label>
                                <input id="httpHeader1Payment" formControlName="httpHeader1" type="text" class="form-control mb-1" placeholder="{{'HTTP Header 1' | translate}}">
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label for="httpHeader1ValuePayment" translate>HTTP Header 1 Value</label>
                                <input id="httpHeader1ValuePayment" formControlName="httpHeader1Value" type="text" class="form-control mb-1" placeholder="{{'HTTP Header 1 Value' | translate}}">
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label for="httpHeader2Payment" translate>HTTP Header 2</label>
                                <input id="httpHeader2Payment" formControlName="httpHeader2" type="text" class="form-control mb-1" placeholder="{{'HTTP Header 2' | translate}}">
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label for="httpHeader2ValuePayment" translate>HTTP Header 2 Value</label>
                                <input id="httpHeader2ValuePayment" formControlName="httpHeader2Value" type="text" class="form-control mb-1" placeholder="{{'HTTP Header 2 Value' | translate}}">
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label for="apiVersion" translate>API Version
                                  <a href="https://developer.paylink.sa/docs/payment-webhook" target="_blank">
                                    <svg width="15" height="15" viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
                                      <g id="Group">
                                        <path id="Path" fill="#06209f" stroke="none"
                                              d="M 683.015686 117.331543 C 526.902344 -38.973694 273.638733 -39.129089 117.331566 116.982361 C -38.973663 273.097717 -39.130989 526.363159 116.984306 682.670349 C 273.095764 838.975586 526.36322 839.130981 682.670349 683.017639 C 838.973694 526.906128 839.130981 273.636841 683.015686 117.331543 Z M 455.850311 653.819031 C 455.850311 659.991028 450.848602 664.988892 444.68042 664.988892 L 355.321472 664.988892 C 349.15332 664.988892 344.151642 659.991028 344.151642 653.819031 L 344.151642 322.097748 C 344.151642 315.925751 349.15332 310.927887 355.321472 310.927887 L 444.68042 310.927887 C 450.848602 310.927887 455.850311 315.923828 455.850311 322.097748 L 455.850311 653.819031 Z M 400.000977 264.571594 C 364.281158 264.571594 335.218811 235.513062 335.218811 199.791382 C 335.218811 164.073486 364.279266 135.009216 400.000977 135.009216 C 435.722656 135.009216 464.783112 164.071594 464.783112 199.791382 C 464.783112 235.513062 435.718811 264.571594 400.000977 264.571594 Z"/>
                                      </g>
                                      <g id="g1"/>
                                    </svg>
                                  </a>
                                </label>
                                <select id="apiVersion" formControlName="version" type="text" class="form-control mb-1">
                                  <option value="v1" translate>v1</option>
                                  <option value="v2" translate>v2</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col">
                              <button class="btn btn-primary" translate (click)="testPaymentWebhook()">Test</button>
                            </div>
                          </div>
                          <!---->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- End of Web Hook Payment -->
    </div>
  </div>

  <!-- Shopify settings -->

  <div *ngIf="includeShopify && (isMerchant || isManager)" class="shopify-content">
    <div class="scrollspy-example" data-spy="scroll" data-target="#account-settings-scroll" data-offset="-100">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 layout-spacing">
          <form id="shopify-info" [formGroup]="form" class="section general-info">
            <div class="info">
              <h6 translate>Shopify Setup</h6>
              <div class="row">
                <div class="col-lg-11 mx-auto">
                  <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 mt-md-0 mt-4">
                      <div class="form">
                        <!---->
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label for="firstName" translate>Shopify Store Domain</label>
                              <input formControlName="shopifyShopDomain" [contentEditable]="false" type="text" class="form-control mb-1" placeholder="{{'myshopify-store-example.com' | translate}}">
                              <button (click)="installShopify()" class="btn btn-primary mt-2" translate>Install Shopify</button>
                            </div>
                          </div>
                        </div>
                        <!---->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 layout-spacing">
          <form id="shopify-orders" [formGroup]="form" class="section general-info">
            <div class="info">
              <h6 translate>Matching Shopify Orders</h6>
              <div class="row">
                <div class="col-lg-11 mx-auto">
                  <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 mt-md-0 mt-4">
                      <div class="form">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label for="firstName" translate>Upload the Shopify orders CSV file from your Shopify store website.</label>
                              <div data-upload-id="shopifyCsv">
                                <label>
                                  <input type="file" class="file-upload" (change)="onFileSelected($event)" accept="text/csv">
                                  <input type="hidden" name="MAX_FILE_SIZE" value="10485760"/>
                                  <span class="custom-file-container__custom-file__custom-file-control"></span>
                                </label>
                              </div>
                              <div *ngIf="downloadingShopify">
                                <div class="d-flex">
                                  <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
                                </div>
                              </div>
                              <button *ngIf="!downloadingShopify" (click)="downloadShopifyOrders()" class="btn btn-primary mt-2" translate>Download orders related to the Shopify CSV file</button>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Account settings footer -->

  <button *ngIf="!submitting && (isMerchant || isManager)" class="btn btn-primary" translate (click)="submitForm()">Save Changes</button>
  <div *ngIf="submitting" class="account-settings-footer">
    <div class="as-footer-container">
      <div *ngIf="submitting" class="mx-auto spinner-grow text-info loader-lg"></div>
    </div>
  </div>

</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
